import React, {Component} from 'react'
import { Link } from 'react-router-dom'

class OperacoeItinerarioEmLote extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="dropdown">
                    <button className="btn btn-laranja dropdown-toggle" type="button" id="dropdownMenuButton"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Alterações em lote
                    </button>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a className="dropdown-item btn btn-laranja" data-toggle="modal"
                           data-target="#modalAlteracaoVeiculoItinerarioEmLote">Alterar veículo</a>
                        <a className="dropdown-item btn btn-laranja" data-toggle="modal"
                           data-target="#modalAlteracaoTipoAjusteItinerarioEmLote">Alterar desconto/acréscimo</a>
                        <a className="dropdown-item btn btn-laranja" data-toggle="modal"
                           data-target="#ModalAlteracaoTipoPrecoItinerarioEmLote">Alterar categoria</a>
                        {this.props.habilitadoSite ?
                            <a className="dropdown-item btn btn-laranja" data-toggle="modal"
                               data-target="#modalHabilitarVendasEmLoteNoSite">Alterar venda no site</a>
                            : ''}
                        <a className="dropdown-item btn btn-laranja" data-toggle="modal"
                           data-target="#modalAlteracaoPrestadorItinerarioEmLote">Alterar prestador</a>
                        <a className="dropdown-item btn btn-laranja" data-toggle="modal"
                           data-target="#modalBloquearItinerarioPorCidadeEmLote">Bloquear itinerario por Cidade</a>
                        <a className="dropdown-item btn btn-laranja" data-toggle="modal"
                           data-target="#modalBloquearUsuarioEmpresaItinerarioPorEmLote">Bloquear venda usuario no itinerário</a>
                        <Link className="dropdown-item btn btn-laranja" to='/painel-ativacao-itinerario'>Alterar ativo/inativo</Link>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default OperacoeItinerarioEmLote
